import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { QuickActionGroup, QuickActionItem } from '../../../../../global/models/quick-actions-model';
import { MapPortalProps } from '../../../models/arc-epi-props';

interface Props {
    group: QuickActionGroup;
    portalProps: MapPortalProps;
    selectedQuickActions: QuickActionItem[];
    expanded: boolean;
    toggleGroupExpanded: (value: React.SetStateAction<string>) => void;
    addQuickAction: (id: React.SetStateAction<string>) => void;
    removeQuickAction: (id: React.SetStateAction<string>) => void;
}
export function QuickActionsGroupDisplay(props: Props) {
    const { group, portalProps, selectedQuickActions, expanded, toggleGroupExpanded, addQuickAction, removeQuickAction } = props;


    const getButtonText = (itemSelected: boolean) => {
        const buttonText = itemSelected ? (portalProps?.removeActionText || 'Remove') : (portalProps?.addActionText || 'Add');

        const svgId = itemSelected ? '#minus-icon' : '#plus-icon';

        return (
            <>
                <svg className='icon' aria-hidden='true' focusable='false'>
                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref={svgId} />
                </svg>
                <span>{buttonText}</span>
            </>
        );

    };

    const renderGroupItem = (item: QuickActionItem) => {
        const itemSelected = selectedQuickActions.some(x => x.id === item.id);
        const buttonClasses = itemSelected ? 'quick-action-accordion-panel-item-button-remove' : 'quick-action-accordion-panel-item-button-add';
        return (
            <div className='quick-action-accordion-panel-item' key={item.id}>
                <p><strong>{item.actionName}</strong></p>
                <button
                    type='button'
                    className={`quick-action-accordion-panel-item-button ${buttonClasses}`}
                    onClick={() => {
                        if (itemSelected) {
                            removeQuickAction(item.id);
                        } else {
                            addQuickAction(item.id);
                        }
                    }}

                >{getButtonText(itemSelected)}</button>
            </div>
        );
    };


    return (
        <>
            <Accordion
                className='quick-action-accordion'
                expanded={expanded}>
                <AccordionSummary
                    className='quick-action-accordion-trigger'

                    aria-controls={`content-${group.groupName}`}
                    id={`header-${group.groupName}`}
                    onClick={() => toggleGroupExpanded(group?.groupName)}>

                    <h5>{group.groupName}</h5>
                    <div className='quick-action-accordion-trigger-indicator'><p className='quick-action-accordion-trigger-indicator-text'><strong>{expanded ? portalProps?.collapseText || 'Collapse' : portalProps?.expandText || 'Expand'}</strong></p> <ExpandMoreIcon /></div>
                </AccordionSummary>
                <AccordionDetails className='quick-action-accordion-panel'>
                    <div className='quick-action-accordion-panel-grid'>
                        {group?.quickActionItems?.map(item => renderGroupItem(item))}
                    </div>
                </AccordionDetails>
            </Accordion>
        </>
    );
}